import AreaRepresentation from "../../components/shared/charts/AreaRepresentation";
import COLOR from "../../theme/colors";

const DailyProductRegistrations = ( {productRegistrations} ) => {
    const {
        datapoints = [],
        title = "Daily Product Registrations",
        // xLabel = "",
        // yLabeL = "",
    } = productRegistrations || {};
    
    return (
        <AreaRepresentation
            data={datapoints}
            title={title}
            color={COLOR.AREA_CHART}
            xAxisDataKey="value"
            yAxisDataKey="count"
        />
    );
};

export default DailyProductRegistrations;
